/** web-studio-sites D7: what the events grid's current state requires a drawing to show (no list with no event). */
import type { RequiredParts } from '../../contract/required';
import { eventCardsRequired } from '../events-row/requiredParts';
import type { EventsGridState } from './contract';

export const requiredParts: RequiredParts<EventsGridState> = (state) =>
  state.events.length === 0 ? [] : [{ part: 'list' }, ...eventCardsRequired(state.events, state.marks)];
